import styled from "styled-components";

const PrimaryButton = styled.button`
  font-family: Dosis;
  font-style: normal;
  color: white;
  font-weight: bold;
  font-size: 20px;
  display: flex;
  align-items: center;
  background: #0e3d71;
  border-radius: 5px;
  min-width: 200px;
  height: 50px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export { PrimaryButton };
